enum RewardCalculationType {
    Static = 'Static',
    // Task 74718 - Refactor SalesIncentives and remove RewardCalculationType.StaticPoints
    StaticPoints = 'StaticPoints',
    Variable = 'Variable',
    UserDefined = 'UserDefined',
    Choice = 'Choice',
    Percentage = 'Percentage',
}

export default RewardCalculationType;
